import React, { useState } from 'react';
import { HelpModalBody } from '../HelpModalBody';
import { copyToClipboard as clipboardCopy } from '../../../utils/CopyUtil';
import { getOS } from '../../../utils';

interface UserData {
  user_types?: Record<string, unknown>;
  rule_sets?: Array<{ label: string; role?: string }>;
  [key: string]: any;
}
interface Props {
  helpMessage: string;
  helpMessageEnabled: boolean;
  isHomeroom: boolean;
  isFoundry: boolean;
  showHelpModal: boolean;
  toggleHelpModal: () => void;
  user?: UserData;
}

export const HelpModal: React.FC<Props> = ({
  helpMessage,
  helpMessageEnabled,
  isFoundry,
  isHomeroom,
  showHelpModal,
  toggleHelpModal,
  user,
}) => {
  const [copySuccess, setCopySuccess] = useState<boolean | null>(null);

  const copyToClipboard = async (): Promise<void> => {
    const field = document.querySelector('#help-modal-info');
    const text = field?.textContent?.toString() ?? '';
    if (!text) {
      setCopySuccess(false);
      return;
    }
    const success = await clipboardCopy(text);
    setCopySuccess(success);
    setTimeout(() => setCopySuccess(null), 2000);
  };

  const cookieEnabled: boolean = typeof window !== 'undefined' && window.navigator.cookieEnabled;
  const currentUrl: string = typeof window !== 'undefined' ? window.location.href : '';
  const userData: UserData = (user && user.attributes ? (user.attributes as UserData) : user) || {};

  const getUserTypes = (userData: UserData): string => {
    const user_types = userData.user_types;
    const rule_sets = userData.rule_sets;
    if (isHomeroom && rule_sets?.length) {
      const roles = rule_sets.map(rs => rs.role || rs.label).filter(Boolean);
      return roles.join(', ');
    }
    let values: string[] = [];
    if (user_types) {
      values = Object.keys(user_types);
    } else if (rule_sets) {
      values = rule_sets.map(rs => rs.label);
    }
    return values.join(', ');
  };

  return (
    <div className="foundry">
      <HelpModalBody
        cookieEnabled={cookieEnabled}
        // @ts-expect-error Type mismatch: copySuccess may be null, but HelpModalBody expects boolean
        copySuccess={copySuccess}
        copyToClipboard={copyToClipboard}
        currentUrl={currentUrl}
        getOS={getOS}
        getUserTypes={getUserTypes}
        helpMessage={helpMessage}
        helpMessageEnabled={helpMessageEnabled}
        isFoundry={isFoundry}
        isHomeroom={isHomeroom}
        showHelpModal={showHelpModal}
        toggleHelpModal={toggleHelpModal}
        // @ts-expect-error Type mismatch: userData shape does not match HelpModalBody prop
        userData={userData}
      />
    </div>
  );
};
